import React, { Component } from 'react'
import { Table } from "antd"
import { observer, inject } from 'mobx-react'

@inject("store") @observer
export default class DataTable extends Component {
  componentDidMount() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list,
      },
    } = this.props
    list.changePagin(selectedPageNumber)
    document.getElementById('contentTop').scrollIntoView(true)
  }

  render() {
    const {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        }
      }
    } = this.props

    const columns = [
      {
        title: "数据来源",
        className: "ta-l",
        dataIndex: "username",
        width: 100,
        fixed: 'left',
      },
      {
        title: "账户名",
        className: "ta-l",
        dataIndex: "accountName",
        width: 100,
        fixed: 'left',
      },{
        title: "检测平台",
        className: "ta-l",
        dataIndex: "platform",
        width: 100,
        fixed: 'left',
      },{
        title: "分组(家系名称)",
        className: "ta-l",
        dataIndex: "groupName",
        width: 150,
        fixed: 'left',
      },{
        title: "芯片类型",
        className: "ta-l",
        dataIndex: "chipType",
        width: 200,
      }, {
        title: "创建时间",
        className: "ta-l",
        dataIndex: "createTime",
        width: 160,
      },{
        title: "任务id",
        className: "ta-l",
        dataIndex: "taskId",
        width: 200,
      }, {
        title: "文件名称",
        className: "ta-l",
        dataIndex: "fileNumber",
        width: 200,
      },{
        title: "上传时间",
        className: "ta-l",
        dataIndex: "uploadTime",
        width: 160,
      }, {
        title: "性别",
        className: "ta-l",
        dataIndex: "sex",
        width: 80
      }, {
        title: "家系关系",
        className: "ta-l",
        dataIndex: "relationName",
        width: 150
      },{
        title: "致病性",
        className: "ta-l",
        dataIndex: "pathogen",
        width: 150
      },
       {
        title: "Sample_Name",
        className: "ta-l",
        dataIndex: "sampleName",
        width: 150
      },
      {
        title: "Call_Rate",
        className: "ta-l",
        dataIndex: "callRate",
        width: 150
      },
      {
        title: "Total_SNP",
        className: "ta-l",
        dataIndex: "totalSnp",
        width: 150
      },
      {
        title: "Coverage",
        className: "ta-l",
        dataIndex: "coverage",
        width: 150
      },
      {
        title: "Coverage_Y",
        className: "ta-l",
        dataIndex: "coverageY",
        width: 150
      },
      {
        title: "SD",
        className: "ta-l",
        dataIndex: "sd",
        width: 150
      },
      {
        title: "Pass",
        className: "ta-l",
        dataIndex: "pass",
        width: 150
      },
     {
        title: "质控信息",
        className: "ta-l",
        dataIndex: "qcOut",
        width: 150
      },
      {
        title: "Report_chr",
        className: "ta-l",
        dataIndex: "reportChr", 
        width: 150
      },
      {
        title: "Haplotype",
        className: "ta-l",
        dataIndex: "haplotype",
        width: 150
      },
      {
        title: "范围",
        className: "ta-l",
        dataIndex: "scope",
        width: 150,
        render: (text) => {
          return (
            <span>{text || '-'}</span>
          )
        }
      },
      {
        title: "M",
        className: "ta-l",
        dataIndex: "maternalBefore2m",
        width: 80,
      },
      {
        title: "P",
        className: "ta-l",
        dataIndex: "paternalBefore2m",
        width: 80,
      },
      {
        title: "M",
        className: "ta-l",
        dataIndex: "maternalBefore1m",
        width: 80,
      },
      {
        title: "P",
        className: "ta-l",
        dataIndex: "paternalBefore1m",
        width: 80,
      }, {
        title: "M",
        className: "ta-l",
        dataIndex: "maternal",
        width: 80,
      }, {
        title: "P",
        className: "ta-l",
        dataIndex: "paternal",
        width: 80,
      },
      {
        title: "M",
        className: "ta-l",
        dataIndex: "maternalAfter1m",
        width: 80,
      }, {
        title: "P",
        className: "ta-l",
        dataIndex: "paternalAfter1m",
        width: 80,
      }, {
        title: "M",
        className: "ta-l",
        dataIndex: "maternalAfter2m",
        width: 80,
      }, {
        title: "P",
        className: "ta-l",
        dataIndex: "paternalAfter2m",
        width: 80,
      },
      {
        title: "ado",
        className: "ta-l",
        dataIndex: "ado",
        width: 80,
      }
    ]

    return (
      <div className="wrapper-box" >
        <Table
          scroll={{ x: 4350 }}
          columns={columns}
          dataSource={tableData.slice()}
          rowKey={record => record.id}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/statistics/containers/DataTable.js